import * as React from "react";

import { titles } from "../../../constants/titles";
import { Context, fetchStudentPlans } from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import StudentHistoryList from "../../../templates/manager/StudentHistoryList";

export default () => {
  const { state, dispatch } = React.useContext(Context);

  React.useEffect(() => {
    dispatch(fetchStudentPlans());
  }, [dispatch]);

  return (
    <div>
      <Breadcrumb currentTitle={titles.useHistories} />
      <StudentHistoryList
        title={titles.useHistories}
        studentPlans={state.student_plans}
      />
    </div>
  );
};
